export const PASSO_INICIAL = 0;                 // Entra na tela inicial e limpa dados do localStorage
export const PASSO_LOADING = 1;                 // Chama no começo da inicialização do SDK
export const PASSO_ERRO_INICIALIZAR_SDK = 2;    // Erro na inicialização do SDK
export const PASSO_TELA_INICIAL = 3;            // Tela inicial da biometria
export const PASSO_INSTRUCOES = 4;              // Tela com instruções pra captura da imagem
export const PASSO_INICIANDO_SESSAO = 5;        // Desabilita o botão de avançar e inicializa a câmera
export const PASSO_VERIFICANDO_STATUS = 6;      // Após a conclusão do match, verifica a situação do processamento
export const PASSO_CONCLUIDO = 7;               // Verificação concluída e reconhecimento confirmado com sucesso (SITUACAO_EXECUTADA_SUCESSO)
export const PASSO_CAMERA_NAO_HABILITADA = 8;   // ?
export const PASSO_ERRO = 9;                    // Erro na verificação (SITUACAO_EXECUTADA_REPROVADA, SITUACAO_SEM_DADOS, SITUACAO_LIVENESS_REPROVADO)

export const SITUACAO_NAO_EXECUTADA = 0;
export const SITUACAO_EXECUTADA_REPROVADA = 1;
export const SITUACAO_EXECUTADA_SUCESSO = 2;
export const SITUACAO_SEM_DADOS = 3; // Não tem biometria no TSE
export const SITUACAO_LIVENESS_REPROVADO = 4;
export const SITUACAO_OBITO = 5;
export const SITUACAO_ERRO_SISTEMA = 6;

export const SERVICO_BIOMETRIA = {
  PROVA_DE_VIDA: 'prova-vida',
  DESBLOQUEIO_EMPRESTIMO_CONSIGNADO: 'desbloqueio-emprestimo-consignado',
  DESBLOQUEIO_MENSALIDADE_ENTIDADE: 'desbloqueio-mensalidade',
  ALTERAR_PAGAMENTO: 'alterar-forma-pagamento'
}

export const INSTRUCAO_LUMINOSIDADE = 'Escolha um ambiente iluminado e sem pessoas ao fundo.'
export const INSTRUCAO_ROSTO = 'Deixe o rosto bem visível. Evite chapéu, óculos de sol ou qualquer coisa que cubra o rosto.'
export const INSTRUCAO_CELULAR = 'Mantenha a câmera do celular, tablet ou computador na altura do rosto. Use a câmera da frente no celular e tablet.'
export const INSTRUCAO_FRAME = 'Mantenha todo o rosto dentro do círculo que aparece na tela, seguindo as orientações.'

export const TEXTO_PROCESSANDO_DADOS = "Aguarde enquanto processamos seus dados.";
export const TEXTO_BOTAO_VOLTAR = "Voltar";
export const TEXTO_BOTAO_AVANCAR = "Avançar";
export const TEXTO_BOTAO_TENTAR_NOVAMENTE = "Tentar de Novo";

const TEXTO_BIOMETRIA_REALIZADA = "Reconhecimento facial realizado com sucesso."
const TEXTO_BIOMETRIA_NAO_REALIZADA = "Reconhecimento facial não realizado."
const TEXTO_HABILITE_ACESSO_CAMERA = "Habilite a permissão de acesso à câmera do seu dispositivo para continuar."

export const obterTextoRetornoBiometria = (serviceName) => {
  switch (serviceName) {
    case SERVICO_BIOMETRIA.DESBLOQUEIO_EMPRESTIMO_CONSIGNADO:
      return {
        TEXTO_SUCESSO: {
          TITULO: TEXTO_BIOMETRIA_REALIZADA,
          DESCRICAO: 'Siga para o botão <strong>Avançar</strong> e libere o benefício para novo empréstimo.',
          BOTAO_PRIMARIO: TEXTO_BOTAO_AVANCAR,
          BOTAO_SECUNDARIO: TEXTO_BOTAO_VOLTAR,
        },
        TEXTO_ERRO: {
          TITULO: TEXTO_BIOMETRIA_NAO_REALIZADA,
          DESCRICAO: 'Siga para o botão <strong>Tentar de Novo</strong> e repita os passos \
                        para liberar o benefício com reconhecimento facial.</br></br> Caso queira apenas \
                        concluir o pedido, siga para o botão <strong>Avançar</strong>. Esta opção não libera o \
                        benefício para novo empréstimo.',
          BOTAO_PRIMARIO: TEXTO_BOTAO_TENTAR_NOVAMENTE,
          BOTAO_SECUNDARIO: TEXTO_BOTAO_AVANCAR,
        },
        TEXTO_ERRO_CAMERA: {
          TITULO: TEXTO_BIOMETRIA_NAO_REALIZADA,
          DESCRICAO: TEXTO_HABILITE_ACESSO_CAMERA,
          BOTAO_PRIMARIO: TEXTO_BOTAO_VOLTAR,
          BOTAO_SECUNDARIO: '',
        }
      };
    case SERVICO_BIOMETRIA.PROVA_DE_VIDA:
      return {
        TEXTO_SUCESSO: {
          TITULO: TEXTO_BIOMETRIA_REALIZADA,
          DESCRICAO: 'Confira a situação da prova de vida.',
          BOTAO_PRIMARIO: TEXTO_BOTAO_VOLTAR,
          BOTAO_SECUNDARIO: '',
        },
        TEXTO_ERRO: {
          TITULO: TEXTO_BIOMETRIA_NAO_REALIZADA,
          DESCRICAO: 'Siga para o botão <strong>Tentar de Novo</strong> e repita os passos \
                        para realizar a prova de vida com reconhecimento facial.',
          BOTAO_PRIMARIO: TEXTO_BOTAO_TENTAR_NOVAMENTE,
          BOTAO_SECUNDARIO: TEXTO_BOTAO_VOLTAR,
        },
        TEXTO_ERRO_CAMERA: {
          TITULO: TEXTO_BIOMETRIA_NAO_REALIZADA,
          DESCRICAO: TEXTO_HABILITE_ACESSO_CAMERA,
          BOTAO_PRIMARIO: TEXTO_BOTAO_VOLTAR,
          BOTAO_SECUNDARIO: '',
        }
      };
    case SERVICO_BIOMETRIA.DESBLOQUEIO_MENSALIDADE_ENTIDADE:
    case SERVICO_BIOMETRIA.ALTERAR_PAGAMENTO:
      return {
        TEXTO_SUCESSO: {
          TITULO: TEXTO_BIOMETRIA_REALIZADA,
          DESCRICAO: 'O reconhecimento facial garante mais segurança nas ações.',
          BOTAO_PRIMARIO: TEXTO_BOTAO_AVANCAR,
          BOTAO_SECUNDARIO: TEXTO_BOTAO_VOLTAR,
        },
        TEXTO_ERRO: {
          TITULO: TEXTO_BIOMETRIA_NAO_REALIZADA,
          DESCRICAO: 'Não foi possível realizar seu reconhecimento facial.',
          BOTAO_PRIMARIO: TEXTO_BOTAO_AVANCAR,
          BOTAO_SECUNDARIO: TEXTO_BOTAO_VOLTAR,
        },
        TEXTO_ERRO_CAMERA: {
          TITULO: TEXTO_BIOMETRIA_NAO_REALIZADA,
          DESCRICAO: TEXTO_HABILITE_ACESSO_CAMERA,
          BOTAO_PRIMARIO: TEXTO_BOTAO_VOLTAR,
          BOTAO_SECUNDARIO: '',
        }
      };
    default: {
      return {
        TEXTO_SUCESSO: {
          TITULO: TEXTO_BIOMETRIA_REALIZADA,
          DESCRICAO: 'O reconhecimento facial garante mais segurança nas ações.',
          BOTAO_PRIMARIO: TEXTO_BOTAO_AVANCAR,
          BOTAO_SECUNDARIO: TEXTO_BOTAO_VOLTAR,
        },
        TEXTO_ERRO: {
          TITULO: TEXTO_BIOMETRIA_NAO_REALIZADA,
          DESCRICAO: 'Não foi possível realizar seu reconhecimento facial.',
          BOTAO_PRIMARIO: TEXTO_BOTAO_TENTAR_NOVAMENTE,
          BOTAO_SECUNDARIO: TEXTO_BOTAO_VOLTAR,
        },
        TEXTO_ERRO_CAMERA: {
          TITULO: TEXTO_BIOMETRIA_NAO_REALIZADA,
          DESCRICAO: TEXTO_HABILITE_ACESSO_CAMERA,
          BOTAO_PRIMARIO: TEXTO_BOTAO_VOLTAR,
          BOTAO_SECUNDARIO: '',
        }
      };
    }
  }
}